import { render, staticRenderFns } from "./DetailClaimPopup.vue?vue&type=template&id=5ea8a965&scoped=true"
import script from "./DetailClaimPopup.vue?vue&type=script&lang=js"
export * from "./DetailClaimPopup.vue?vue&type=script&lang=js"
import style0 from "./DetailClaimPopup.vue?vue&type=style&index=0&id=5ea8a965&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8a965",
  null
  
)

export default component.exports